let fns = {
    reiniciarErrores: function(action, name) {
        if (action) action = '[data-action="' + action + '"]';
        else action = '[data-action]';

        if (name) name = '[name="' + name + '"]';
        else name = '[name]';

        $(action + ' .alert').fadeOut();

        $(action + ' .alert-danger').html('');

        $(action + ' ' + name + '.is-invalid')
            .removeClass('is-invalid')
            .siblings('.invalid-feedback')
            .html('');

        $('#bobinaHelp').show();
    },

    gestionarErrores: function(validationError) {
        reiniciarErrores(validationError.action);
        var erroresGlobales = [];
        var action = '[data-action="' + validationError.action + '"]';

        $.each(validationError.dicErrors, function(index, errores) {
            var input = action + ' [name="' + index + '"]';

            if (index == 'GLOBAL' || $(input).length == 0) {
                erroresGlobales = erroresGlobales.concat(errores);
            } else {
                $(input).addClass('is-invalid');
                if ($(input).siblings('.invalid-feedback').length == 0)
                    $(input).after('<div class="invalid-feedback"></div>');

                $(input)
                    .siblings('.invalid-feedback')
                    .html(errores.join('<br/>'));
            }
        });

        if (erroresGlobales.length > 0) {
            if ($(action + ' .alert-danger').length == 0) {
                var divGlobal =
                    '<div class="form-row alert alert-danger" style="display:none;" role="alert" name="GLOBAL"></div>';

                if ($(action + ' .form-row.actions:last').length == 0) $(action).append(divGlobal);
                else $(divGlobal).insertBefore(action + ' .form-row.actions:last');
            }

            $(action + ' .alert-danger')
                .html(erroresGlobales.join('<br/>'))
                .fadeIn();
        }

        var input = action + ' .is-invalid';
        if ($(input).length > 0) {
            $(input)[0].focus();
            $(input)[0].blur();
        }

        $('#bobinaHelp').hide();
    },

    genPass: function(len, lower, upper, number, other) {
        templen = len - (lower ? 1 : 0) - (upper ? 1 : 0) - (number ? 1 : 0) - (other ? 1 : 0);

        var coun = 0;
        var text = '';
        var numberChars = '0123456789';
        var lowerChars = 'abcdefghijklmnopqrstuvwxyz';
        var upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var otherChars = '`~!@#$%^&*()-_=+[{]}\\|;:\'",<.>/?';

        if (lower) {
            templen = templen + 1 - coun;
            coun = Math.floor(Math.random() * templen) + (upper || number || other ? 1 : templen);

            for (var i = 0; i < coun; i++) text += lowerChars.charAt(Math.floor(Math.random() * lowerChars.length));
        }

        if (upper) {
            templen = templen + 1 - coun;
            coun = Math.floor(Math.random() * templen) + (number || other ? 1 : templen);

            for (var i = 0; i < coun; i++) text += upperChars.charAt(Math.floor(Math.random() * upperChars.length));
        }

        if (number) {
            templen = templen + 1 - coun;
            coun = Math.floor(Math.random() * templen) + (other ? 1 : templen);

            for (var i = 0; i < coun; i++) text += numberChars.charAt(Math.floor(Math.random() * numberChars.length));
        }

        if (other) {
            templen = templen + 1 - coun;
            coun = Math.floor(Math.random() * templen) + templen;

            for (var i = 0; i < coun; i++) text += otherChars.charAt(Math.floor(Math.random() * otherChars.length));
        }

        text = text.substring(0, len);

        var a = text.split(''),
            n = a.length;

        for (var i = n - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = a[i];
            a[i] = a[j];
            a[j] = tmp;
        }
        text = a.join('');

        return text;
    },

    getPassword: function(
        length,
        extraChars,
        firstNumber,
        firstLower,
        firstUpper,
        firstOther,
        latterNumber,
        latterLower,
        latterUpper,
        latterOther
    ) {
        var rc = '';

        if (length > 0) rc += getRandomChar(firstNumber, firstLower, firstUpper, firstOther, extraChars);

        for (var idx = 1; idx < length; ++idx)
            rc += getRandomChar(latterNumber, latterLower, latterUpper, latterOther, extraChars);

        return rc;
    },

    startsWith: function(string, character) {
        return string.indexOf(character) === 0;
    },

    isEmail: function(val) {
        var plant = /[^\w^@^\.^-]+/gi;
        if (plant.test(val)) return false;
        else {
            plant = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            return plant.test(val);
        }
    },

    converValidDate: function(dateTime) {
        var re = /Date\((\d+)\)/;
        var dateRex = re.exec(dateTime);
        if (dateRex) dateTime = new Date(parseInt(dateRex[1]));

        if (Object.prototype.toString.call(dateTime) !== '[object Date]') dateTime = new Date(dateTime);

        return dateTime;
    },

    getDateFormat: function(dateTime, format) {
        if (dateTime) {
            dateTime = converValidDate(dateTime);

            if (!isNaN(dateTime.getTime())) return $.format.date(dateTime, format);
        }

        return '';
    },

    getWeek: function(semana) {
        if (!semana || semana.split('/').length < 2) return '';

        var newSemana = semana.split('/')[1] + '/' + semana.split('/')[0] + '/' + semana.split('/')[2];

        var d = converValidDate(newSemana);
        var dayNum = d.getUTCDay() || 7;
        dayNum = dayNum + 1;
        if (dayNum == 8) dayNum = 1;
        d.setUTCDate(d.getUTCDate() + 4 - dayNum);
        var yearStart = converValidDate(Date.UTC(d.getUTCFullYear(), 0, 1));
        return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    },

    getMonthName: function(fecha) {
        if (!fecha || fecha.split('/').length < 1) return '';

        var mes = fecha.split('/')[1] - 1;
        return lstMeses[mes /*getDateFormat(fecha, 'MM') - 1*/];
    },

    getYear: function(fecha) {
        if (!fecha || fecha.split('/').length < 2) return '';

        var year = fecha.split('/')[2];
        return year;
    },

    unique: function(lst) {
        return lst.filter(function(value, index, self) {
            var indexof = -1;

            for (var i = 0; i < lst.length; i++) {
                if (JSON.stringify(lst[i]) === JSON.stringify(value)) indexof = i;
            }

            return indexof === index;
        });
    },

    uniqueByProperty: function(lst, key) {
        var result = lst.reduce(function(memo, e1) {
            var matches = memo.filter(function(e2) {
                return e1[key] === e2[key];
            });
            if (matches.length === 0) memo.push(e1);
            return memo;
        }, []);

        result = result.map(function(item) {
            return item[key];
        });

        return result;
    },

    uniqueByProperties: function(lst, keyArray) {
        var result = lst.reduce(function(memo, e1) {
            var matches = memo.filter(function(e2) {
                var igual = true;
                $.each(keyArray, function(index, key) {
                    if (e1[key] !== e2[key]) igual = false;
                });
                return igual;
            });
            if (matches.length === 0) memo.push(e1);
            return memo;
        }, []);

        result = result.map(function(item) {
            var obj = {};
            $.each(keyArray, function(index, key) {
                obj[key] = item[key];
            });
            return obj;
        });

        return result;
    },

    filterByProperty: function(lst, key, value) {
        if (!lst) return [];

        var obj = lst.filter(function(element) {
            if (element[key]) element[key] = element[key].toString();

            if (value) value = value.toString();

            if (element[key] == value) return element;
        });

        if (!obj) obj = [];

        return obj;
    },

    excludeByProperty: function(lst, key, value) {
        if (!lst) return [];

        var obj = lst.filter(function(element) {
            if (element[key]) element[key] = element[key].toString();

            if (value) value = value.toString();

            if (element[key] != value) return element;
        });

        if (!obj) obj = [];

        return obj;
    },

    findByProperty: function(lst, key, value, defaultValue = {}) {
        if (!lst) return defaultValue;

        var obj = lst.filter(function(element) {
            if (element[key]) element[key] = element[key].toString();

            if (value) value = value.toString();

            if (element[key] == value) return element;
        });

        if (!obj || !obj.length > 0) return defaultValue;

        return obj[0];
    },

    indexByProperty: function(lst, key, value) {
        var index = -1;

        if (!lst) return index;

        lst.forEach(function(element, i) {
            if (element[key]) element[key] = element[key].toString();

            if (value) value = value.toString();

            if (element[key] == value) {
                index = i;
                return;
            }
        });

        return index;
    },

    inverseFindByProperty: function(lst, key, value) {
        if (!lst) return {};

        var obj = lst.filter(function(element) {
            if (element[key] && value && element[key].toString() !== value.toString()) return element;
        });

        if (!obj || !obj.length > 0) return {};

        return obj[0];
    },

    replaceByProperty: function(lst, key, value, obj) {
        if (!lst) return [];

        return lst.map(function(element) {
            if (element[key] == value) return obj;
            else return element;
        });
    },

    sumByProperty: function(lst, key, def) {
        var suma = 0;
        if (def === null || def === undefined) def = 0;
        if (lst) {
            lst.map(function(element) {
                if (key !== null && key !== undefined) {
                    if (element[key] && !isNaN(element[key])) suma += parseFloat(element[key]);
                } else if (element && !isNaN(element)) suma += parseFloat(element);
            });
        }

        return suma === 0 ? def : suma;
    },

    sortByProperty: function(lst, key) {
        lst = lst.slice().sort(function(a, b) {
            var aName;
            var bName;
            if (a[key] && a[key].toString() === a[key]) aName = a[key].toLowerCase();
            else aName = a[key];

            if (b[key] && b[key].toString() === b[key]) bName = b[key].toLowerCase();
            else bName = b[key];

            return aName < bName ? -1 : aName > bName ? 1 : 0;
        });

        return lst;
    },

    anyByProperty: function(lst, key, value) {
        if (!lst) return false;

        return lst.some(function(x) {
            return x[key] == value;
        });
    },

    any: function(lst, value) {
        if (!lst) return false;

        return lst.some(function(x) {
            return x == value;
        });
    },

    arrayAddRemoveByProperty: function(lst, key, value) {
        if (!lst) return [];

        var obj = this.findByProperty(lst, key, value[key]);
        if (obj[key]) lst.splice(lst.indexOf(obj), 1);
        else lst.push(value);

        return lst;
    },

    arrayAddRemove: function(lst, value) {
        if (!lst) return [];

        if (this.any(lst, value)) lst.splice(lst.indexOf(value), 1);
        else lst.push(value);

        return lst;
    },

    searchByProperty: function(lst, key, search) {
        if (!lst) return [];

        if (!search || search.length < 1) return lst;

        var myReg = new RegExp(search.toString().toLowerCase() + '.*');

        var obj = lst.filter(function(element) {
            if (element[key]) element[key] = element[key].toString();

            if (element[key].toLowerCase().match(myReg)) return element;
        });

        if (!obj) obj = [];

        return obj;
    },

    roundTo: function(n, digits) {
        var negative = false;
        if (digits === undefined) {
            digits = 0;
        }
        if (n < 0) {
            negative = true;
            n = n * -1;
        }
        var multiplicator = Math.pow(10, digits);
        n = parseFloat((n * multiplicator).toFixed(11));
        n = (Math.round(n) / multiplicator).toFixed(digits);
        if (negative) {
            n = (n * -1).toFixed(2);
        }
        return n;
    },

    formatNumber: function(number, decimales, returnZeros) {
        returnZeros = typeof returnZeros !== 'undefined' ? returnZeros : true;

        if (isNaN(number)) number = 0;

        if (!isNaN(decimales)) number = roundTo(number, decimales);

        var x = number.toString().split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? sepDecimal + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + sepMillar + '$2');
        }

        result = x1 + x2;

        if (returnZeros == false) {
            if (result == 0 || result == '0') result = '';
        }
        return result;
    },

    toggleSameLevel: function(element) {
        if ($(element).hasClass('show'))
            $(element)
                .siblings('.toggle')
                .hide();
        else
            $(element)
                .siblings('.toggle')
                .show();

        $(element).toggleClass('show');
    },

    openNewWindow: function(strUrl) {
        window.open(strUrl);
    },

    isNullOrWhitespace: function(input) {
        if (typeof input === 'undefined' || input == null) return true;

        return input.replace(/\s/g, '').length < 1;
    },

    orderObjectByValue: function(obj) {
        return Object.fromEntries(Object.entries(obj).sort(([, a], [, b]) => (a == b ? 0 : a > b ? 1 : -1)));
    },
};

export default fns;
